<ion-app>
  <ion-router-outlet (activate)="hideLoader()"></ion-router-outlet>
</ion-app>
